import { AchievementDefinition } from '../services/GameAPI';

export const STEP_SKIP_REPEAT_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "ssr-first-answer",
    gameId: "step-skip-repeat",
    title: "First Move!",
    description: "Made your first correct decision in Step, Skip, or Repeat.",
    iconUrl: "💃",
    museCashReward: 25,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "progression"
  },
  {
    id: "ssr-first-step",
    gameId: "step-skip-repeat",
    title: "Step by Step",
    description: "Correctly identified your first 'step'.",
    iconUrl: "🚶",
    museCashReward: 50,
    type: "discovery",
    rarity: "common",
    implemented: true,
    sortOrder: 2,
    category: "knowledge"
  },
  {
    id: "ssr-first-skip",
    gameId: "step-skip-repeat",
    title: "Skip to It",
    description: "Correctly identified your first 'skip'.",
    iconUrl: "🤸",
    museCashReward: 50,
    type: "discovery",
    rarity: "common",
    implemented: true,
    sortOrder: 3,
    category: "knowledge"
  },
  {
    id: "ssr-first-repeat",
    gameId: "step-skip-repeat",
    title: "Repeat Performer",
    description: "Correctly identified your first 'repeat'.",
    iconUrl: "🔁",
    museCashReward: 50,
    type: "discovery",
    rarity: "common",
    implemented: true,
    sortOrder: 4,
    category: "knowledge"
  },
  {
    id: "ssr-five-correct",
    gameId: "step-skip-repeat",
    title: "Getting the Groove",
    description: "Made 5 correct moves in a single session.",
    iconUrl: "🕺",
    museCashReward: 100,
    type: "milestone",
    rarity: "rare",
    implemented: true,
    sortOrder: 5,
    category: "progression"
  }
]; 